import appBulkBonusDetails from "../../views/appSettings/bulkBonusDetails.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("bulkbonus", {
    url: "bulk-bonus/:id",
    parent: "app",
    views: {
      view: {
        template: appBulkBonusDetails,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkBonus" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkBonusDetails/bulkBonusDetails.urls.js